import { businessQuestions, servicePages } from "./service-content";

export const canonicalOrigin = "https://housespace.us";
const description = "Construction and remodeling for homes and businesses in Central and Southwest Ohio. Serving Columbus, Dayton, and Cincinnati. Request a free estimate.";
export const publicPaths = ["/", ...servicePages.map((service) => `/services/${service.slug}/`)];
export const renderedPaths = [...publicPaths, "/privacy-policy/"];

export function normalizePath(path: string) {
  const clean = path.split(/[?#]/)[0].replace(/\/+$/, "");
  return clean ? `${clean}/` : "/";
}

export function pageMetadata(path: string) {
  const pathname = normalizePath(path);
  const service = servicePages.find((item) => pathname === `/services/${item.slug}/`);
  const privacy = pathname === "/privacy-policy/";
  const title = service
    ? `${service.title} in Ohio | HouseSpace`
    : privacy ? "Privacy policy | HouseSpace Ohio" : "Ohio Remodeling & Construction | HouseSpace";
  const summary = service ? service.summary : privacy
    ? "Read how HouseSpace handles inquiry information, retention, service providers, cookies, and requests about your personal information."
    : description;
  const url = `${canonicalOrigin}${pathname}`;
  const business = {
    "@type": "GeneralContractor", "@id": `${canonicalOrigin}/#business`,
    name: "HouseSpace", legalName: "House Space Design LLC", url: `${canonicalOrigin}/`,
    telephone: "+16143320622", email: "support@housespace.us",
    logo: `${canonicalOrigin}/brand/house-mark.png`,
    image: `${canonicalOrigin}/images/porch-1280.webp`,
    address: {
      "@type": "PostalAddress", streetAddress: "1306 West Broad St", addressLocality: "Columbus",
      addressRegion: "OH", postalCode: "43222", addressCountry: "US",
    },
    areaServed: ["Central Ohio", "Southwest Ohio", "Columbus, Ohio", "Dayton, Ohio", "Cincinnati, Ohio"],
    openingHoursSpecification: [{
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"], opens: "09:00", closes: "17:00",
    }],
  };
  const graph: Record<string, unknown>[] = [
    business,
    { "@type": "WebSite", "@id": `${canonicalOrigin}/#website`, name: "HouseSpace", url: `${canonicalOrigin}/`, publisher: { "@id": business["@id"] }, inLanguage: "en-US" },
    { "@type": "WebPage", "@id": `${url}#webpage`, url, name: title, description: summary, isPartOf: { "@id": `${canonicalOrigin}/#website` }, about: { "@id": business["@id"] } },
  ];
  if (service) {
    graph.push({
      "@type": "Service", "@id": `${url}#service`, name: service.title, description: service.summary,
      url, provider: { "@id": business["@id"] }, areaServed: business.areaServed,
    }, {
      "@type": "BreadcrumbList", itemListElement: [
        { "@type": "ListItem", position: 1, name: "HouseSpace", item: `${canonicalOrigin}/` },
        { "@type": "ListItem", position: 2, name: "Services", item: `${canonicalOrigin}/#services` },
        { "@type": "ListItem", position: 3, name: service.title, item: url },
      ],
    });
  }
  return {
    pathname, title, description: summary, url, privacy,
    image: `${canonicalOrigin}/images/social-preview.png`,
    schema: { "@context": "https://schema.org", "@graph": graph },
  };
}

// These answers are rendered visibly; no FAQ rich-result or AI citation is promised.
export { businessQuestions };
